export default __webpack_public_path__ + "static/media/1.b1edf536.png";